import { renderRoutes } from 'react-router-config';

export function EmployeeMainPage({ route }) {
  return renderRoutes(route.routes);
}
